import IMask from 'imask'
import { convertMaskString, currencyMaskOptions, currencySignedMaskOptions, DocumentFieldCnpjMask, DocumentFieldCpfMask } from '@utils/fields'

/**
 * Format a currency field value
 *
 * @param value
 * @returns
 */
export const formatCurrencyField = (value: string, allowSigned: boolean = false) => {
  const mask = allowSigned ? currencySignedMaskOptions : currencyMaskOptions;
  return IMask.pipe(value, convertMaskString(mask));
}

/**
 * Format a Document field value to masked
 *
 * @param value
 * @returns
 */
export const formatDocumentField = (value: string) => {
  const parsed = value.replace(/[^0-9a-z]/gi, '');
  return (parsed.length <= 11) ? formatCpfField(value) : formatCnpjField(value);
};

/**
 * Format a CPF field value to masked
 *
 * @param value
 * @returns
 */
export const formatCpfField = (value: string) => {
  return IMask.pipe(value, { prepareChar: (str) => str.toUpperCase(), ...DocumentFieldCpfMask });
};

/**
 * Format a CNPJ field value to masked
 *
 * @param value
 * @returns
 */
export const formatCnpjField = (value: string) => {
  return IMask.pipe(value, { prepareChar: (str) => str.toUpperCase(), ...DocumentFieldCnpjMask });
};
